<template>
  <div class="home-about">
    <div class="top-content">
      <h3 v-viewportChanged="showView" class="hidden-element top-title">{{ pr.title }}</h3>
      <div v-viewportChanged="showView" class="hidden-element top-subtitle">
        <break-text :content="pr.subtitle1"></break-text>
        <break-text :content="pr.subtitle2"></break-text>
      </div>
      <p
        v-viewportChanged="showView"
        v-html="description"
        class="hidden-element top-description pc"
      ></p>
      <p
        v-viewportChanged="showView"
        v-html="descriptionMiddle"
        class="hidden-element top-description pc-middle"
      ></p>
      <p
        v-viewportChanged="showView"
        v-html="description"
        class="hidden-element top-description sp"
      ></p>
      <div class="map pc">
        <div class="map-img">
          <div class="map-img-wrapper">
            <div
              v-for="item in markerList"
              :key="item.id"
              :class="['map-address', { active: active > -1 && item.id === pr.list[active].id }]"
            >
              <div
                :class="['map-item marker', { disabled: item.disabled }]"
                :style="{
                  left: item.position.icon[0] + 'px',
                  top: item.position.icon[1] + 'px',
                }"
                @click="() => {
                  if (!item.disabled && !item.link) {
                    selectMarker(item.id);
                  }
                  selectLinkBlank(item);
                }"
              ></div>
              <span
                :class="['map-item name', { link: item.link, disabled: item.disabled }]"
                :style="{
                  left: item.position.name[0] + 'px',
                  top: item.position.name[1] + 'px',
                }"
                @click="() => {
                  if (!item.disabled && !item.link) {
                    selectMarker(item.id);
                  }
                  selectLinkBlank(item);
                }"
              >
                {{ item.name }}
                <img
                  v-if="item.link"
                  :src="require('@/assets/external_link_icon.svg')"
                  alt="map-link"
                  aria-hidden="true"
                />
              </span>
            </div>
          </div>
        </div>
        <img src="@/assets/shadow_left.png" alt="" class="shadow left" />
        <img src="@/assets/shadow_right.png" alt="" class="shadow right" />
      </div>
      <div class="map sp">
        <img class="map-img" src="@/assets/img_map_sp@3x.png" alt="map" />
      </div>
    </div>
    <div id="about-info-pc" class="about-info pc">
      <ul class="tabs">
        <li
          v-for="(item, index) in pr.list"
          :key="item.id"
          :class="['tab', 'text-hover', { active: active === index }]"
          @click="active = index"
        >
          {{ item.title }}
        </li>
      </ul>
      <Info v-if="activeInfo" :key="`${locale}-${activeInfo.id}`" :model="activeInfo" :language="locale" />
    </div>
    <div id="about-info-sp" class="about-info sp">
      <Info v-for="item in pr.list" :key="item.id" :model="item" :language="locale" />
    </div>
  </div>
</template>

<script>
import { inject, ref } from 'vue';
import usePageResource from '@/composables/usePageResource';
import { FenrirLink } from '@/constants/constants';
import BreakText from '@/components/common/BreakText.vue';
import Info from './Info.vue';

export default {
  name: 'home-about',
  components: {
    Info,
    BreakText,
  },
  data() {
    return {
      markerList: [
        {
          id: 'sh',
          name: 'Shanghai',
          position: {
            icon: [364, 117],
            name: [445, 193],
          },
        },
        {
          id: 'cd',
          name: 'Chengdu',
          position: {
            icon: [291, 117],
            name: [165, 187],
          },
        },
        {
          id: 'dl',
          name: 'Dalian',
          position: {
            icon: [374, 76],
            name: [462, 48],
          },
        },
        {
          id: 'jfi',
          name: 'Japan Fenrir Inc.',
          position: {
            icon: [429, 100],
            name: [503, 79],
          },
          link: 'https://www.fenrir-inc.com/jp/',
        },
        {
          id: 'sv',
          name: 'Silicon Valley',
          position: {
            icon: [752, 76],
            name: [608, 144],
          },
          disabled: true,
        },
      ],
    };
  },
  computed: {
    description() {
      return this.pr.description
        .replace(/\t/gm, '')
        .replace(/\n/gm, '<br/>')
        .replace('Fenrir Inc.', `<a href="${FenrirLink}" target="_blank">Fenrir Inc.</a>`);
    },
    descriptionMiddle() {
      return this.pr.description
        .replace(/\t/gm, '<br/>')
        .replace(/\n/gm, '<br/>')
        .replace('Fenrir Inc.', `<a href="${FenrirLink}" target="_blank">Fenrir Inc.</a>`);
    },
    cd() {
      return this.pr.cd;
    },
    dl() {
      return this.pr.dl;
    },
    activeInfo() {
      return this.pr.list[this.active] || this.pr.list[0] || null;
    },
  },
  setup() {
    const { pr } = usePageResource('about');
    const locale = inject('locale');
    const active = ref(0);
    return {
      pr,
      locale,
      active,
    };
  },
  mounted() {
    this.$bus.$on('show-about-info', this.selectMarker);
  },
  unmounted() {
    this.$bus.$off('show-about-info', this.selectMarker);
  },
  methods: {
    selectMarker(id) {
      this.active = this.pr.list.findIndex((o) => o.id === id);
    },
    selectLinkBlank(item) {
      if (item.disabled) return;

      if (item.link) {
        window.open(item.link, '_blank');
      }
    },
  },
};
</script>

<style scoped lang="scss">
@use 'sass:math';

.tabs {
  display: flex;
  justify-content: center;
  list-style: none;
  border-bottom: 1px solid #a6aeb1;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  @media screen and (max-width: 768px) {
    justify-content: start;
  }
}

.tab {
  box-sizing: border-box;
  min-width: 178px;
  width: 196px;
  height: 73px;
  text-align: center;
  line-height: 73px;
  color: #a6aeb1;
  font-size: 18px;
  letter-spacing: 2.8px;
  font-weight: bold;
  user-select: none;
  cursor: pointer;

  &.active {
    $color: #212121;
    color: $color;
    border-bottom: 4px solid $color;
  }
}

.pc {
  &.top-description {
    @media screen and (max-width: 910px) {
      display: none;
    }
  }

  &.map {
    @media screen and (max-width: 414px) {
      display: none;
    }
  }

  &.about-info {
    @media screen and (max-width: 768px) {
      display: none;
    }

    margin: 0 auto;
    max-width: 1200px;
  }
}

.pc-middle {
  &.top-description {
    @media screen and (min-width: 911px), (max-width: 768px) {
      display: none;
    }
  }
}

.sp {
  &.top-description {
    @media screen and (min-width: 769px) {
      display: none;
    }
  }
  &.map {
    @media screen and (min-width: 415px) {
      display: none;
    }
  }

  &.about-info {
    @media screen and (min-width: 769px) {
      display: none;
    }
  }
}

.home-about {
  padding: 0 20px 100px;
  color: #222;

  .top {
    &-content {
      overflow: auto;
      text-align: center;

      .map {
        width: 100%;

        &.pc {
          $mapWidth: 1111px;
          $mapHeight: 471px;

          position: relative;
          margin-bottom: 48px;
          height: $mapHeight;
          overflow: hidden;

          .map-img {
            position: absolute;
            left: calc(50% - #{math.div($mapWidth, 2)} + 60px);
            width: $mapWidth;
            height: 100%;
            background-image: url('~@/assets/img_map_pc@3x.png');
            background-repeat: no-repeat;
            background-size: $mapWidth $mapHeight;
            transform: scale(0.9);

            @media screen and (max-width: 768px) {
              left: calc(50% - #{math.div($mapWidth, 2)} + 46px);
              transform: scale(0.5);
            }

            &-wrapper {
              position: relative;
              width: 100%;
              height: 100%;

              .map-address {
                @mixin marker-active {
                  z-index: 10;
                  transform: scale(1);
                }
                &.active {
                  .map-item {
                    &.marker {
                      @include marker-active;
                    }
                  }
                }

                &:not(.active) {
                  .map-item {
                    &.name:hover {
                      opacity: 0.7;
                    }

                    &.marker:hover {
                      @include marker-active;
                    }
                  }
                }
              }

              .map-item {
                position: absolute;
                cursor: pointer;
                transition-duration: 100ms;

                &.name {
                  font-size: 18px;
                  font-weight: 500;
                  color: #3784e6;
                  line-height: 25px;
                  user-select: none;

                  >img {
                    filter: brightness(0) saturate(100%)
                    invert(45%) sepia(93%) saturate(1800%)
                    hue-rotate(190deg) brightness(95%) contrast(90%);
                  }

                  &.link:hover {
                    text-decoration: underline;
                  }
                }

                &.marker {
                  width: 38px;
                  height: 60px;
                  background-image: url('~@/assets/coordinate_big@3x.png');
                  background-repeat: no-repeat;
                  background-size: 100%;
                  transform: scale(0.63);
                  transform-origin: center bottom;
                }

                &.disabled {
                  pointer-events: none;
                }
              }
            }
          }

          .shadow {
            position: absolute;
            top: 0;

            &.left {
              left: 0;
            }

            &.right {
              right: 0;
            }
          }
        }

        &.sp {
          max-width: 326px;
          margin: 0 auto 40px;

          .map-img {
            width: 100%;
          }
        }
      }
    }

    &-title {
      margin-top: 72px;
      font-size: 30px;
      line-height: 42px;
    }

    &-subtitle {
      margin: 31px 0 15px;
      font-size: 20px;
      line-height: 28px;
      font-weight: bold;
    }

    &-description {
      margin-bottom: 56px;
      font-size: 14px;
      line-height: 24px;

      @media only screen and (max-width: 800px) {
        margin-bottom: 40px;
      }
    }

    @media only screen and (max-width: 800px) {
      &-description {
        text-align: left;
      }

      &-title {
        margin-top: 56px;
        font-size: 22px;
        line-height: 30px;
      }

      &-subtitle {
        margin: 29px 0 15px;
        font-size: 18px;
        line-height: 30px;
        letter-spacing: -1px;
      }

      &-description {
        margin-bottom: 40px;
        font-size: 15px;
        line-height: 30px;
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  .home-about {
    padding: 0 24px 70px;
  }
}
</style>
